import { render, staticRenderFns } from "./Generative.vue?vue&type=template&id=c8d148d2&scoped=true&"
import script from "./Generative.vue?vue&type=script&lang=js&"
export * from "./Generative.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=c8d148d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d148d2",
  null
  
)

export default component.exports